import React from 'react'
import { storyblokEditable } from "@storyblok/react";
import resolveLink from "src/utils/resolveLink";
import Label from "src/utils/Label";
import Heading from "src/utils/Heading";
import RichText from "src/utils/RichText";
import { useForm } from "react-hook-form";
import { navigate } from "gatsby";
import TextInput from "./Components/TextInput";
import EmailInput from "./Components/EmailInput";
import TextAreaInput from "./Components/TextAreaInput";
import FileInput from "./Components/FileInput";
import NumberInput from "./Components/NumberInput";
import SelectInput from "./Components/SelectInput";
import RadioButtons from "./Components/RadioButtons";
import Checkboxes from "./Components/Checkboxes";
import ConsentInput from "./Components/ConsentInput";
import CtaReferrer from "./Components/CtaReferrer";
import HiddenInput from "./Components/HiddenInput";
import Gclid from "./Components/Gclid";

const Components = {
  "text-input": TextInput,
  "email-input": EmailInput,
  "textarea-input": TextAreaInput,
  "file-input": FileInput,
  "number-input": NumberInput,
  "select-input": SelectInput,
  "radio-buttons": RadioButtons,
  "checkboxes": Checkboxes,
  "consent-input": ConsentInput,
  "cta-referrer": CtaReferrer,
  "hidden-input": HiddenInput,
  "gclid": Gclid,
};

const Form = ({ blok }) => {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  function encode(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === "object") {
        formData.append(key, value[0]);
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  }

  const onSubmit = (data) => {
    fetch("/", {
      method: "POST",
      body: encode(data),
    })
    .then(() => {
      window?.dataLayer?.push({
        event: "form-submission",
        formName: blok.name,
      });
      navigate(resolveLink(blok.action.cached_url));
    })
    .catch((error) => console.log(error));
  };

  return (
      <div className="bg-white">
        <div className="mx-auto lg:py-52 py-36 max-w-7xl px-6 flex lg:flex-row flex-col justify-start items-start lg:gap-40 gap-12">
          <div className={`lg:w-6/12 w-full max-w-lg`}>
            <Label className="mb-8 text-black">{blok.label}</Label>
            {blok.title && (
                <Heading size="h1" className="lg:!text-[110px] !text-6xl !leading-[0.8] !mb-8 text-black">{blok.title}</Heading>
            )}
            {blok.description && (
                <div className="prose text-base md:text-lg tracking-[-0.05em] text-black">
                  <RichText>{blok.description}</RichText>
                </div>
            )}
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            name={blok.name}
            id={blok.name}
            className="flex flex-col lg:w-6/12 w-full"
            data-netlify="true"
          >
            <Label className="mb-6">{blok.form_label}</Label>
            <div className="grid grid-cols-6 gap-x-4">
              {blok.fields.map((field) => {
                const Component = Components[field.component];
                return (
                  field.name &&
                    <Component
                      blok={field}
                      register={register}
                      watch={watch}
                      errors={errors}
                      storyblokEditable={storyblokEditable(field)}
                      key={field._uid}
                    />
                );
              })}
            </div>
            <input
              {...register("form-name")}
              type="hidden"
              name="form-name"
              value={blok.name}
            />
            <button
              type="submit"
              className="relative cursor-pointer overflow-hidden inline-flex self-end justify-center items-center px-[30px] py-[20px] font-display !tracking-[0.01em] !leading-[1.5rem] font-extrabold bg-indigo-700 border uppercase transition duration-300 lg:text-2xl text-1.5xl border-black text-white"
            >
              {blok.button_text}
            </button>
          </form>
        </div>
      </div>
  );
};

export default Form;
